// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__3HquD","success":"FinishedQuiz_success__2qHlN","failed":"FinishedQuiz_failed__2H3cp"};